
import { Component, Vue } from 'vue-property-decorator';
import { EscalationInterface, EscalationRepositoryInterface } from '../../../../services/QA/escalation/interfaces';
import ChatRepositoryInterface, {
  ChatInterface,
  chatRateMap,
  ChatScoreInterface,
  ChatWSMessageInterface, MessageRecipientsType,
} from '../../../../services/QA/chat/interfaces';
import TagRepositoryInterface, { TagInterface } from '../../../../services/QA/tag/interfaces';
import ScoreTypeRepositoryInterface, { ScoreTypeInterface } from '../../../../services/QA/scoreType/interfaces';
import ScoreGradeRepositoryInterface, { ScoreGradeInterface } from '../../../../services/QA/scoreGrade/interfaces';
import { UserHasScopes } from '../../../middleware/Route/Auth';
import { Roles } from '@/services/Roles';
import NoteRepositoryInterface, { ChatNoteInterface, NoteInterface } from '../../../../services/QA/note/interfaces';
import { UserBaseInfoInterface, UserRepoInterface } from '../../../../services/Users/Interfaces';
import CommentRepositoryInterface, {
  ChatCommentInterface,
  CommentInterface,
  UpdateChatCommentInterface,
  UpdateMessageCommentInterface,
} from '../../../../services/QA/comment/interfaces';
import { WPXFormValue } from '../../../../components/templates/WPXForm';
import { ReviewChatForm } from '@/services/QA/chat/forms/ReviewChatForm';
import { EscalationStatus } from '@/services/QA/escalation';
import Themeable from 'vuetify/lib/mixins/themeable';
import EscalateDialog from '../../../../components/dialogs/qa/escalation/EscalateDialog.vue';
import ChatMessageImageDialog from '../../../../components/dialogs/qa/chat/ChatMessageImageDialog.vue';
import FeedbackDialog from '../../../../components/dialogs/qa/feedback/FeedbackDialog.vue';
import DeleteCommentDialog from '../../../../components/dialogs/qa/comment/DeleteCommentDialog.vue';
import DeleteNoteDialog from '@/components/dialogs/qa/note/DeleteNoteDialog.vue';
import EditCommentDialog from '@/components/dialogs/qa/comment/EditCommentDialog.vue';
import EditNoteDialog from '@/components/dialogs/qa/note/EditNoteDialog.vue';
import { ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'escalationRepository',
    'scoreGradeRepository',
    'scoreTypeRepository',
    'tagRepository',
    'noteRepository',
    'commentRepository',
    'userRepository',
    'chatRepository',
    'profileRepository',
  ],
  components: {
    EscalateDialog,
    ChatMessageImageDialog,
    FeedbackDialog,
    DeleteCommentDialog,
    DeleteNoteDialog,
    EditCommentDialog,
    EditNoteDialog,
  },
  sockets: {
    chatData(msg: ChatWSMessageInterface): void {
      this.$emit('updateChatData', msg.chat);
    },
    newChatComment(msg: { chatComment: ChatCommentInterface }): void {
      this.$emit('updateChatComments', msg.chatComment);
    },
    newMessageComment(msg: { messageComment: ChatCommentInterface }): void {
      this.$emit('updateMessageComments', msg.messageComment);
    },
    newChatPrivateNote(msg: { chatNote: ChatNoteInterface }): void {
      this.$emit('updateChatPrivateNote', msg.chatNote);
    },
    updatedComment(msg: { comment: CommentInterface }): void {
      this.$emit('updatedCommentMessage', msg.comment);
    },
    updatedNote(msg: { note: NoteInterface }): void {
      this.$emit('updatedNoteMessage', msg.note);
    },
  },
})
export default class ChatEscalation extends Vue {
  private escalation!: EscalationInterface;
  private chat!: ChatInterface;
  private chatData!: ChatInterface;
  private loading: boolean = true;
  private valid: boolean = false;
  private tags: TagInterface[] = [];
  private tagsSelected: number[] = [];
  private scoreTypes: ScoreTypeInterface[] = [];
  private scoreGrades: ScoreGradeInterface[] = [];
  private comment: string = '';
  private privateNote: string = '';
  private messageComment: string = '';
  private scores: { [scoreTypeId: number]: number } = {};
  private scoresSelected: unknown[] = [];
  private height: number = 0;
  private userHasScopes: object = UserHasScopes;
  private userRoles: object = Roles;
  private chatRateMap: { '0': string, '1': string, '2': string } = chatRateMap;

  private escalationRepository!: EscalationRepositoryInterface;
  private scoreTypeRepository!: ScoreTypeRepositoryInterface;
  private scoreGradeRepository!: ScoreGradeRepositoryInterface;
  private chatRepository!: ChatRepositoryInterface;
  private tagRepository!: TagRepositoryInterface;
  private noteRepository!: NoteRepositoryInterface;
  private userRepository!: UserRepoInterface;
  private profileRepository!: ProfileRepositoryInterface;
  private commentRepository!: CommentRepositoryInterface;
  private form: WPXFormValue<ReviewChatForm> = new WPXFormValue(ReviewChatForm);
  private usersMap: { [userId: string]: UserBaseInfoInterface } = {};

  private urlForDialog: string | false = false;
  private imageDialog: string = '';
  private escalateDialog: string = '';
  private feedbackDialog: string = '';
  private commentIdForDialog: number = 0;
  private deleteCommentDialog: string | false = false;
  private deletedScores: ChatScoreInterface[] = [];
  private noteIdForDialog: number = 0;
  private deleteNoteDialog: string | false = false;
  private commentIdForEditDialog: number = 0;
  private commentContentForDialog: string = '';
  private editCommentDialog: string | false = false;
  private noteIdForEditDialog: number = 0;
  private noteContentForDialog: string = '';
  private editNoteDialog: string | false = false;

  private responseReceived: boolean = false;
  private messageReceived: boolean = false;


  public async beforeCreate(): Promise<void> {

    this.$on('updateChatData', async (chat: ChatInterface) => {
      this.messageReceived = true;
      await this.mergeChatProperties(chat);
    });

    this.$on('updateChatComments', async (chatComment: UpdateChatCommentInterface) => {
      if (chatComment.chatId === this.chat.id) {
        if (!this.usersMap[chatComment.comment.authorId]) {
          const user = await this.userRepository.getUsersByIds([chatComment.comment.authorId]);
          this.usersMap[user[0].id] = user[0];
        }
        this.chat.comments.push(chatComment);
        this.chat.comments = this.chat.comments.sort(
          (commentA, commentB) => commentA.comment.timestamp - commentB.comment.timestamp,
        );
      }
      this.$forceUpdate();
    });

    this.$on('updateMessageComments', async (messageComment: UpdateMessageCommentInterface) => {
      const messageIndex = this.chat.messages.findIndex((chatMessage) => chatMessage.id === messageComment.messageId);
      if (messageIndex !== -1) {
        if (!this.usersMap[messageComment.comment.authorId]) {
          const user = await this.userRepository.getUsersByIds([messageComment.comment.authorId]);
          this.usersMap[user[0].id] = user[0];
        }
        this.chat.messages[messageIndex].comments.push(messageComment);
        this.chat.messages[messageIndex].comments = this.chat.messages[messageIndex].comments.sort(
          (commentA, commentB) => commentA.comment.timestamp - commentB.comment.timestamp,
        );
      }
      this.$forceUpdate();
    });

    this.$on('updateChatPrivateNote', (chatNote: ChatNoteInterface) => {
      if (chatNote.chatId === this.chat.id) {
        this.chat.notes.push(chatNote);
        this.chat.notes = this.chat.notes.sort(
          (noteA, noteB) => noteA.note.timestamp - noteB.note.timestamp,
        );
      }
      this.$forceUpdate();
    });

    this.$on('updatedCommentMessage', (comment: CommentInterface) => {
      let commentIndex = this.chat.comments.findIndex((chatComment) => chatComment.comment.id === comment.id);

      if (commentIndex !== -1) {
        this.chat.comments[commentIndex].comment = comment;
      } else {
        let messageIndex = -1;

        this.chat.messages.forEach((message, mi) => {
          message.comments.forEach((messageComment, ci) => {
            if (messageComment.comment.id === comment.id) {
              messageIndex = mi;
              commentIndex = ci;
            }
          });
        });

        if (messageIndex !== -1 && commentIndex !== -1) {
          this.chat.messages[messageIndex].comments[commentIndex].comment = comment;
        }
      }

      this.$forceUpdate();
    });

    this.$on('updatedNoteMessage', (note: NoteInterface) => {
      const noteIndex = this.chat.notes.findIndex((chatNote) => chatNote.note.id === note.id);

      if (noteIndex !== -1) {
        this.chat.notes[noteIndex].note = note;
      }

      this.$forceUpdate();
    });
  }

  public async created(): Promise<void> {
    await this.initialize();
    // @ts-ignore
    this.height = this.$parent.$el.offsetHeight;
  }

  public async initialize(): Promise<void> {
    const escalation = await this.escalationRepository.getEscalation(Number(this.$route.params.escalationId));
    this.escalation = escalation.escalation;
    this.chat = escalation.chat;
    this.responseReceived = true;

    await this.getUsersInfo();

    this.tags = await this.tagRepository.getActiveTags();
    this.scoreTypes = await this.scoreTypeRepository.getAllScoreTypes();
    this.scoreGrades = await this.scoreGradeRepository.getAllScoreGrades();

    this.chat.scores.forEach((chatScore) => {
      if (!chatScore.score.deletedAt) {
        this.scores[chatScore.score.type.id] = chatScore.score.grade.id;
      } else {
        this.deletedScores.push(chatScore);
      }
    });

    this.valid = Object.keys(this.scores).length === this.scoreTypes.length;
    this.tagsSelected = this.chat.tags.map((tag) => tag.id);
  }

  private addScore(scoreTypeId: number, scoreGradeId: number): void {
    this.scores[scoreTypeId] = scoreGradeId;
    this.valid = Object.keys(this.scores).length === this.scoreTypes.length;
  }

  private removeScore(scoreTypeId: number): void {
    delete this.scores[scoreTypeId];
    this.valid = Object.keys(this.scores).length === this.scoreTypes.length;
  }

  private async reviewEscalation(): Promise<void> {
    try {
      await this.escalationRepository.reviewEscalation(
        this.escalation.id,
        this.chat.agents.filter((agent) => !!agent.id).map((agent) => String(agent.id)),
        this.scores,
        this.tagsSelected,
        this.chat.id,
      )
      ;
      this.escalation.status = EscalationStatus.REVIEWED;
      this.$successDialog.show('Review Success!');
      this.$forceUpdate();
    } catch (e) {
      console.log(e);
      this.$errorDialog.show(e.response?.data?.message);
    }
  }


  private async prepareCommentForEdit(commentId: number): Promise<void> {
    let commentIndex = this.chat.comments.findIndex((comment) => comment.comment.id === commentId);
    if (commentIndex !== -1) {
      this.commentIdForEditDialog = this.chat.comments[commentIndex].comment.id;
      this.commentContentForDialog = this.chat.comments[commentIndex].comment.content;
      this.editCommentDialog = 'edit-comment-dialog';
    } else {
      let messageIndex = -1;

      this.chat.messages.forEach((message, mi) => {
        message.comments.forEach((messageComment, ci) => {
          if (messageComment.comment.id === commentId) {
            messageIndex = mi;
            commentIndex = ci;
          }
        });
      });

      this.commentIdForEditDialog = this.chat.messages[messageIndex].comments[commentIndex].comment.id;
      this.commentContentForDialog = this.chat.messages[messageIndex].comments[commentIndex].comment.content;
      this.editCommentDialog = 'edit-comment-dialog';
    }
  }

  private async editComment(commentId: number, content: string): Promise<void> {
    let commentIndex = this.chat.comments.findIndex((comment) => comment.comment.id === commentId);
    if (commentIndex !== -1) {
      this.chat.comments[commentIndex].comment.content = content;
    } else {
      let messageIndex = -1;

      this.chat.messages.forEach((message, mi) => {
        message.comments.forEach((messageComment, ci) => {
          if (messageComment.comment.id === commentId) {
            messageIndex = mi;
            commentIndex = ci;
          }
        });
      });

      this.chat.messages[messageIndex].comments[commentIndex].comment.content = content;
    }
  }

  private async prepareNoteForEdit(noteId: number): Promise<void> {
    const noteIndex = this.chat.notes.findIndex((chatNote) => chatNote.note.id === noteId);
    if (noteIndex !== -1) {
      this.noteIdForEditDialog = this.chat.notes[noteIndex].note.id;
      this.noteContentForDialog = this.chat.notes[noteIndex].note.content;
      this.editNoteDialog = 'edit-note-dialog';
    }
  }

  private async editNote(noteId: number, content: string): Promise<void> {
    const noteIndex = this.chat.notes.findIndex((chatNote) => chatNote.note.id === noteId);
    if (noteIndex !== -1) {
      this.chat.notes[noteIndex].note.content = content;
    }
  }

  private async deleteComment(commentId: number): Promise<void> {
    this.commentIdForDialog = commentId;
    this.deleteCommentDialog = 'delete-comment-dialog';
  }

  private async deleteNote(noteId: number): Promise<void> {
    this.noteIdForDialog = noteId;
    this.deleteNoteDialog = 'delete-note-dialog';
  }

  private removeNote(noteId: number): void {
    const noteIndex = this.chat.notes.findIndex((chatNote) => chatNote.note.id === noteId);

    if (noteIndex !== -1) {
      delete this.chat.notes[noteIndex];
      this.chat.notes = this.chat.notes.filter((note) => !!note);
    }

    this.$forceUpdate();
  }

  private removeComment(commentId: number): void {
    let commentIndex = this.chat.comments.findIndex((chatComment) => chatComment.comment.id === commentId);

    if (commentIndex !== -1) {
      delete this.chat.comments[commentIndex];
      this.chat.comments = this.chat.comments.filter((comment) => !!comment);
    } else {
      let messageIndex = -1;
      this.chat.messages.forEach((message, mi) => {
        message.comments.forEach((messageComment, ci) => {
          if (messageComment.comment.id === commentId) {
            messageIndex = mi;
            commentIndex = ci;
          }
        });

      });

      delete this.chat.messages[messageIndex].comments[commentIndex];
      this.chat.messages[messageIndex].comments = this.chat.messages[messageIndex]
        .comments.filter((comment) => !!comment);
    }

    this.$forceUpdate();
  }

  private async feedback(): Promise<void> {
    this.feedbackDialog = 'feedback-dialog';
  }

  private async addComment(): Promise<void> {
    try {
      const commentDTO: Partial<CommentInterface> = {
        content: this.comment,
        authorId: this.$store.getters.id,
        timestamp: Math.floor(Date.now() / 1000),
      };

      await this.commentRepository.addChatComment(this.chat.id, commentDTO, true);
      this.comment = '';

      if (this.escalation.status !== EscalationStatus.IN_PROGRESS) {
        this.escalation.status = EscalationStatus.IN_PROGRESS;
        await this.escalationRepository.changeEscalationStatus(this.escalation.id, EscalationStatus.IN_PROGRESS);
      }

    } catch (err) {
      this.$errorDialog.show(err.response?.data?.message);
    }
  }

  private async addNote(): Promise<void> {
    try {
      const note: Partial<NoteInterface> = {
        content: this.privateNote,
        authorId: this.$store.getters.id,
        timestamp: Math.floor(Date.now() / 1000),
      };

      await this.noteRepository.addChatNote(this.chat.id, note, true);
      this.privateNote = '';

      if (this.escalation.status !== EscalationStatus.IN_PROGRESS) {
        this.escalation.status = EscalationStatus.IN_PROGRESS;
        await this.escalationRepository.changeEscalationStatus(this.escalation.id, EscalationStatus.IN_PROGRESS);
      }

    } catch (err) {
      console.log(err);
      this.$errorDialog.show(err.response?.data?.message);
    }
  }

  private async addCommentToMessage(messageId: number): Promise<void> {
    try {
      const comment: Partial<CommentInterface> = {
        content: this.messageComment,
        authorId: this.$store.getters.id,
        timestamp: Math.floor(Date.now() / 1000),
      };

      await this.commentRepository.addMessageComment(this.chat.id, messageId, comment, true);
      this.messageComment = '';

      if (this.escalation.status !== EscalationStatus.IN_PROGRESS) {
        this.escalation.status = EscalationStatus.IN_PROGRESS;
        await this.escalationRepository.changeEscalationStatus(this.escalation.id, EscalationStatus.IN_PROGRESS);
      }
    } catch (err) {
      this.$errorDialog.show(err.response?.data?.message);
    }
  }

  private async mergeChatProperties(chatData: ChatInterface): Promise<void> {
    if (!this.responseReceived) {
      setTimeout(() => this.mergeChatProperties(chatData), 200);
      return;
    }

    if (this.chat.id !== chatData.id) {
      this.messageReceived = false;
      return;
    }

    this.chat.startedTimestamp = chatData.startedTimestamp;
    this.chat.endedTimestamp = chatData.endedTimestamp;
    this.chat.visitor = chatData.visitor;
    this.chat.agents = chatData.agents;
    this.chat.supervisors = chatData.supervisors;
    this.chat.rate = chatData.rate;
    this.chat.messages.map((message) => {
      const index = chatData.messages?.findIndex((msg) => {
        return msg.id === message.id;
      });

      message.comments = message.comments.sort(
        (commentA, commentB) => commentA.comment.timestamp - commentB.comment.timestamp,
      );
      return Object.assign(message, chatData.messages[index]);
    });

    this.chat.messages.map((message) => {
      message.isWhisper = message.recipients === MessageRecipientsType.AGENTS;

      return message;
    });

    this.chat.messages.sort((messageA, messageB) => messageA.timestamp - messageB.timestamp);
    this.chat.comments.sort((commentA, commentB) => commentA.comment.timestamp - commentB.comment.timestamp);
    this.chat.notes.sort((noteA, noteB) => noteA.note.timestamp - noteB.note.timestamp);

    const users = await this.userRepository.getUsersByEmails([
      ...this.chat.agents.map((agent) => agent.login),
      ...this.chat.supervisors.map((supervisor) => supervisor.login),
    ]);

    const usersProfiles = await this.profileRepository
      .getBaseProfileDataByUsersIds(users.map((user) => String(user.id)));

    users.forEach((user) => {
      const profileIndex = usersProfiles.findIndex((profile) => profile.userId === String(user.id));
      if (profileIndex === -1) {
        return;
      }

      const agentIndex = this.chat.agents.findIndex((agent) => agent.login === user.email);
      if (agentIndex !== -1) {
        this.chat.agents[agentIndex].id = user.id;
        this.chat.agents[agentIndex].fullName =
          `${usersProfiles[profileIndex].firstName} ${usersProfiles[profileIndex].lastName}`;
      }

      const supervisorIndex = this.chat.supervisors.findIndex((supervisor) => supervisor.login === user.email);
      if (supervisorIndex !== -1) {
        this.chat.supervisors[supervisorIndex].id = user.id;
        this.chat.supervisors[supervisorIndex].fullName =
          `${usersProfiles[profileIndex].firstName} ${usersProfiles[profileIndex].lastName}`;
      }
    });

    if (this.responseReceived && this.messageReceived) {
      this.loading = false;
    }
  }

  private showCommentArea(messageId: number): void {
    const index = this.chat.messages.findIndex((message) => message.id === messageId);
    this.chat.messages.forEach((message, i) => {
      if (i !== index) {
        message.commentInputVisible = false;
      }
    });
    this.chat.messages[index].commentInputVisible = !this.chat.messages[index].commentInputVisible;
    this.$forceUpdate();
  }

  private showImage(url: string): void {
    this.imageDialog = 'chat-message-image-dialog';
    this.urlForDialog = url;
  }

  private async closeReview(): Promise<void> {
    await this.$router.back();
  }

  private async getUsersInfo(): Promise<void> {
    const usersIds: string[] = [];
    this.chat.comments.forEach((chatComment) => {
      if (usersIds.indexOf(chatComment.comment.authorId) === -1) {
        usersIds.push(chatComment.comment.authorId);
      }
    });

    this.chat.notes.forEach((chatNote) => {
      if (usersIds.indexOf(chatNote.note.authorId) === -1) {
        usersIds.push(chatNote.note.authorId);
      }
    });

    this.chat.messages.forEach((message) => {
      message.comments.forEach((messageComment) => {
        if (usersIds.indexOf(messageComment.comment.authorId) === -1) {
          usersIds.push(messageComment.comment.authorId);
        }
      });
    });

    if (usersIds.indexOf(this.chat.reviewerId) === -1) {
      usersIds.push(this.chat.reviewerId);
    }

    if (usersIds.indexOf(this.escalation.escalatedFromUserId) === -1) {
      usersIds.push(this.escalation.escalatedFromUserId);
    }

    if (this.escalation.departmentManager && usersIds.indexOf(this.escalation.departmentManager) === -1) {
      usersIds.push(this.escalation.departmentManager);
    }

    if (this.escalation.shiftManager && usersIds.indexOf(this.escalation.shiftManager) === -1) {
      usersIds.push(this.escalation.shiftManager);
    }

    const users = await this.userRepository.getUsersByIds(usersIds);
    users.forEach((user) => {
      this.usersMap[user.id] = user;
    });
  }
}
